import { SignatureType } from "../common/enums";

type Signature = {
    id: number;
    base64Signature: string;
    signatureType: SignatureType;
    nameClarification: string;
    phoneNumber?: string;
    createdAt: Date;
    canRemove: boolean;
    canCreate: boolean;
};

export default Signature;

export function Signature_empty(
    signatureType = SignatureType.PermitProvider,
    canCreate = false,
    canRemove = false
): Signature {
    return {
        id: 0,
        base64Signature: "",
        canCreate: canCreate,
        canRemove: canRemove,
        nameClarification: "",
        phoneNumber: "",
        signatureType,
        createdAt: new Date()
    };
}

export function Signature_normalize(signature: Signature, signatureType: SignatureType): Signature {
    if (!signature) {
        return Signature_empty(signatureType);
    }

    const normalizedSignature: Signature = {
        ...signature,
        createdAt: signature.createdAt ? new Date(signature.createdAt) : new Date()
    };

    return normalizedSignature;
}

export function Signature_isEmpty(signature: Signature): boolean {
    return !signature || !signature.id;
}
